import { FaqCategoryItem } from "../../types";

import { SCHOOL_YEAR_UPDATE_FAQ } from "./SchoolYearUpdateFaq";
import { BULK_STUDENT_REGISTRATION_FAQ } from "./BulkStudentRegistrationFaq";
import { DEACTIVATE_ACCOUNT_FAQ } from "./DeactivateAccountFaq";
import { BILLING_INQUIRY_FAQ } from "./BillingInquiryFaq";

export const SETTING_ITEMS: FaqCategoryItem[] = [
  SCHOOL_YEAR_UPDATE_FAQ,
  BULK_STUDENT_REGISTRATION_FAQ,
  DEACTIVATE_ACCOUNT_FAQ,
  BILLING_INQUIRY_FAQ,
];
